import React from "react";
import {Row, Col, Button, Modal, Form, Input, Spin} from "antd";
import "./BeneficiaryInformationPanel.scss";
import FieldValueVerticalCell from "components/general/FieldValueVerticalCell";
import { getRelationshipNameByValue } from "domain/BeneficiaryRelationship";
import { getCountryNameByCode } from "utils/utils";
import {
  checkBeneficiaryHasOrder,
  getCountryList,
  getNationalityList,
  getRelationshipCode,
  linkBeneficiaryToDBS,
  linkOriginatorToDBS,
  getHongKongSourceAccountCurrency,
  linkBeneficiaryToFlashFx, getVirtualAccountBalanceByVirtualAccId,
} from "../api/api";
import {displayError, displayGenericError, displaySuccessMessageWithSeconds} from "../common/notifications";

import { FormattedMessage } from "react-intl";
import withUseIntl from "components/withUseIntl";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {DbsChannelComponent} from "./DbsChannelComponent";
import {Spinner} from "react-bootstrap";
const confirm = Modal.confirm;

class BeneficiaryInformationPanel extends React.Component {
  state ={
    showVABrdgx: false,
    hideEdit: false,
    vaLocation: '',
    selectedVaId:null
  }
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    checkBeneficiaryHasOrder(this.props.beneficiary.id).then(res => {
      this.setState({
        hideEdit:res
      })
    })
  }

  showVABrdgx = () => {
    let virtualAccounts = this.props.beneficiary.virtualAccounts;
    let hasFlashFXVA  = virtualAccounts.findIndex(item => item.virtualAccountChannelCode == 'FLASH_FX')>=0;
    let hasDBSHKVA  = virtualAccounts.findIndex(item => item.virtualAccountChannelCode == 'DBS_HK')>=0;

    this.setState({
      showVABrdgx:true,
      hasDBSHKVA:hasDBSHKVA,
      hasFlashFXVA:hasFlashFXVA
    })
  }

  hideVABrdgx = () => {
    this.setState({
      showVABrdgx:false
    })
  }

  // buildBalanceStr = (balanceStr) => {
  //   if(balanceStr && balanceStr.includes(",")){
  //     let balanceArr = balanceStr.replace(/,/g,"\n");
  //     // let balanceArr = balanceStr.split(",");
  //     return balanceArr;
  //   } else{
  //     return balanceStr
  //   }
  // }

  selectedVaId = (vaId) =>{
    let selectedVaId = this.state.selectedVaId;
    this.setState({
      selectedVaId:vaId
    })
    getVirtualAccountBalanceByVirtualAccId(vaId).then(res =>{
      const intl = this.props.useIntl;
      let beneficiary = this.props.beneficiary;
      let virtualAccounts = beneficiary.virtualAccounts;
      if(virtualAccounts) {
        virtualAccounts.forEach(item=>{
          if(res.balance) {
            if (item.id === vaId) {
              item.vaBalanceStr = res.balance;
              item.vaBalanceStrClaimed = res.claimedBalance;
            }
          }else {
            item.vaBalanceStr=[];
            item.vaBalanceStrClaimed=[];
          }
        })
      }
     this.props.updateBeneficiary (this.props.idxOfCurrentBene,beneficiary);
      this.setState({
        selectedVaId:null
      })

    }).catch(e=>{
      displayError(JSON.stringify(e));
      this.setState({
        selectedVaId:null
      })
    })
  }

  buildVaBalanceInfo = (id,virtualAccountNumber,vaBalanceStr) => {
    const intl = this.props.useIntl;
    if (!virtualAccountNumber) {
      return null;
    }
    if (vaBalanceStr) {

      let result = Object.entries(vaBalanceStr).map((k, v) => {
        let s = `${k}\n`;
        return s.replaceAll(",", ": ");
      })

      if (result.length == 0) {
        result = intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance.empty"});
      }

      return (
          <FieldValueVerticalCell
              style={{whiteSpace: "pre-line"}}
              className="bp-table-cell"
              title={intl.formatMessage({id: "app.page.dashboardrxpage.balanceonhold"})}
              value={result}
          />
      );
    } else {
      if (this.state.selectedVaId === id) {
        return <Spin/>;
      } else {
        return (
          <>
            <p class="field-value-cell-header" style={{paddingBottom: "6px", marginBottom: 0}}>{intl.formatMessage({id: "app.page.dashboardrxpage.balanceonhold"})}</p>
            <Button type={'link'} onClick={() => {
              this.selectedVaId(id);
            }}>{intl.formatMessage({id: "app.common.show"})}</Button>
          </>   
        );
      }
    }
  }

  buildVaBalanceInfoClaimed = (id,virtualAccountNumber,vaBalanceStrClaimed) => {
    const intl = this.props.useIntl;
    if (!virtualAccountNumber) {
      return null;
    }
    if (vaBalanceStrClaimed) {

      let result = Object.entries(vaBalanceStrClaimed).map((k, v) => {
        let s = `${k}\n`;
        return s.replaceAll(",", ":");
      })

      if (result.length == 0) {
        result = intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance.empty"});
      }

      return (
          <FieldValueVerticalCell
              style={{whiteSpace: "pre-line"}}
              className="bp-table-cell"
              title={intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"})}
              value={result}
          />
      );
    } else {
      if (this.state.selectedVaId === id) {
        return <Spin/>;
      } else {
        return (
            <FieldValueVerticalCell
                style={{whiteSpace: "pre-line"}}
                className="bp-table-cell"
                title={intl.formatMessage({id: "app.page.dashboardrxpage.claimedbalance"})}
                value={'-'}
            />
        );
      }
    }
  }

  buildVirtualAccountInfo = () => {
    const intl = this.props.useIntl;
    // if(this.props.currentCustomer.accountType ==='PERSONAL') {
    //   return null;
    // }
    if(!this.props.beneficiary.virtualAccounts) {
      return null;
    }

    if(this.props.beneficiary.virtualAccounts.length == 0) {
      return (
          <>
            <div className="beneficiary-information-panel">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.beneficiaryinformationpanel.virtualaccount"/>
              </h6>
              <div className="bp-bordered-panel bp-margin-top-smallest-2">
                <Row gutter={16}>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountLocation"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountCurrency"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountNumber"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountName"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountBalance"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountStatus"})}
                        value={"-"}
                    />
                  </Col>
                  <Col md={6} sm={8}>
                    <FieldValueVerticalCell
                        className="bp-table-cell"
                        title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountswift"})}
                        value={"-"}
                    />
                  </Col>
                </Row>
              </div>
            </div>
          </>
      )
    }

    if(this.props.beneficiary.virtualAccounts.length > 0) {
      return (
          <>
            <div className="beneficiary-information-panel">
              <h6 className={"fw-600"}><FormattedMessage id="app.panel.beneficiaryinformationpanel.virtualaccount"/>
              </h6>
              <div className="bp-bordered-panel bp-margin-top-smallest-2">
                {
                  this.props.beneficiary.virtualAccounts.map((item, i) => {
                    let location = '';
                    if(item.virtualAccountChannelCode=='DBS_HK' ) {
                      location ="Hong Kong"
                    } else if (item.virtualAccountChannelCode=='DBS_SG') {
                      location ="Singapore"
                    } else if (item.virtualAccountChannelCode=='SAHABAT_SAMPOERNA') {
                      location ="Indonesia"  
                    } else if (item.virtualAccountChannelCode=='FLASH_FX') {
                      location ="Australia"  
                    }
                    
                    var virtualAccountNumber = null;
                    if(item.virtualAccountStatus=='UNVERIFIED' ) {
                      virtualAccountNumber = "-";
                    } else {
                      virtualAccountNumber = item.virtualAccountNumber;
                    }
                    
                    var swift = null;
                    if (location === 'HK') {
                      swift = this.props.hkSourceAccountCurrency.bankSwift;
                    } else if (location === 'SG') {  
                      swift = 'FAST transfer only';
                    } else {
                      swift = 'Local transfer only';
                    }

                    return (
                        <Row gutter={16}>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountLocation"})}
                                value={location}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountCurrency"})}
                                value={item.currencies}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountNumber"})}
                                value={virtualAccountNumber}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountName"})}
                                value={item.virtualAccountName}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            {this.buildVaBalanceInfo(item.id,item.virtualAccountNumber,item.vaBalanceStr)}
                          </Col>
                          <Col md={6} sm={8}>
                            {this.buildVaBalanceInfoClaimed(item.id,item.virtualAccountNumber,item.vaBalanceStrClaimed)}
                          </Col>

                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountStatus"})}
                                value={item.virtualAccountStatus}
                            />
                          </Col>
                          <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccountswift"})}
                                value={swift}
                            />
                          </Col>

                          {item.virtualAccountChannelCode=='FLASH_FX' && <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.virtualaccount.bsbCode"})}
                                value={item.bsbCode}
                            />
                          </Col>}
                        </Row>
                    );
                  })
                }

              </div>
            </div>
          </>
      )
    }
  }

  handleOnVaLocationChange = (value, event) => {
    this.setState({
      vaLocation: value
    })
  }

  handleDbsAcc = () => {
    const intl = this.props.useIntl;

    if(!this.state.vaLocation) {
      displayError(intl.formatMessage({id:"app.panel.beneficiaryinformationpanel.select.vabrdgx"}));
      return;
    }

    confirm({
      title: <p> {intl.formatMessage({id:"app.panel.beneficiaryinformationpanel.doyouwantcreate.vabrdgx"})} </p>,
      onOk: () => {
        this.setState({
          isLoading: true
        });
        
        let beneficiary = this.props.beneficiary;

        let vaChannelCode = '';
        if(this.state.vaLocation=='Hong Kong' ) {
          vaChannelCode ="DBS_HK"
        } else if (this.state.vaLocation=='Singapore') {
          vaChannelCode ="DBS_SG"
        } else if (this.state.vaLocation=='Indonesia') {
          vaChannelCode ="SAHABAT_SAMPOERNA"  
        } else if (this.state.vaLocation=='Australia') {
          vaChannelCode ="FLASH_FX"  
       }

        let virtualDbsReq = {
          beneficiaryId: beneficiary.id,
          virtualAccountChannelCode: vaChannelCode
        };
        this.setState({
          isLoading: true,
        });

        if (this.state.vaLocation=='Hong Kong') {
          linkBeneficiaryToDBS(virtualDbsReq)
            .then(response => {
              let beneficiary = this.props.beneficiary;
              response.balanceStr='0.00';
              beneficiary.virtualAccounts.push(response);

              this.props.updateBeneficiary(this.props.idxOfCurrentBene,beneficiary);
              this.setState({
                isLoading: false,
              });
              displaySuccessMessageWithSeconds(intl.formatMessage({id:"app.common.successfully"}),3);
              return response;
            })
            .catch(error => {
              this.setState({
                isLoading: false,
              });
              displayError(error.result);
            });
        } else if (this.state.vaLocation=='Australia') {
          linkBeneficiaryToFlashFx(virtualDbsReq)
            .then(response => {
              let beneficiary = this.props.beneficiary;
              response.balanceStr='0.00';
              beneficiary.virtualAccounts.push(response);

              this.props.updateBeneficiary(this.props.idxOfCurrentBene,beneficiary);
              this.setState({
                isLoading: false,
              });
              displaySuccessMessageWithSeconds(intl.formatMessage({id:"app.common.successfully"}),3);
              return response;
            })
            .catch(error => {
              this.setState({
                isLoading: false,
              });
              displayError(error.result);
            });
        }

        this.setState({
          showVABrdgx: false
        });
        
      }
    })
  }

  buildBankAccountName(selectedBeneficiary) {
    const intl = this.props.useIntl;
    let bankAccName = "-";
    if(selectedBeneficiary) {
      if(selectedBeneficiary.bankAccountName) {
        bankAccName = selectedBeneficiary.bankAccountName;
      } else{
        if(selectedBeneficiary.beneficiaryType == "INDIVIDUAL") {
          bankAccName = selectedBeneficiary.firstName + " " + selectedBeneficiary.lastName;
        }else {
          bankAccName = selectedBeneficiary.businessName;
        }
      }
    }
    return (
        <Col md={6} sm={8}>
          <FieldValueVerticalCell
              className="bp-table-cell bp-margin-top-smallest"
              title={intl.formatMessage({id: "app.modal.bankaccountinformationtab.bank.account.name"})}
              value={bankAccName}
          />
        </Col>
    );
  }

  buildVAButton = () => {
    if(this.props.currentCustomer.accountType ==='PERSONAL') {
      return null;
    }
    if (!this.props.currentCustomer.enableVaLegs || !this.props.currentCustomer.enableVaLegs.includes('BENEFICIARY')) {
      return null;
    }
    if(this.props.currentUser && !this.props.currentUser.role.readOnly) {
      if(this.props.beneficiary.virtualAccounts) {
        let checkDBSHKExisted = this.props.beneficiary.virtualAccounts.find(item => item.virtualAccountChannelCode === 'DBS_HK');
        let checkExistFlashFX = this.props.beneficiary.virtualAccounts.find(item => item.virtualAccountChannelCode === 'FLASH_FX');
        if (checkDBSHKExisted && checkExistFlashFX) {
          return null;
        }
        return (<Button
            type="primary"
            onClick={() =>
                this.showVABrdgx()
            }
        >
          <FormattedMessage id="app.panel.beneficiaryinformationpanel.create.vabrdgx"/>
        </Button>)
      }
    }
    return null;
  }

  render() {
    const intl = this.props.useIntl;
    let reason = this.props.relations.filter(s => s.code === this.props.beneficiary.relationship).length > 0
        ? this.props.relations.filter(s => s.code === this.props.beneficiary.relationship)[0].value : '';

    let country = this.props.countries.filter(s => s.countryCode === this.props.beneficiary.bankCountry).length > 0 ?
        this.props.countries.filter(s => s.code === this.props.beneficiary.countries)[0].country : '';
    let isPartner = false;
    let originator= (this.props.beneficiary.originators && this.props.beneficiary.originators.length>0) ? this.props.beneficiary.originators[0] : {};
    let displayNumber;
    let displayName;
    let industry;
    let nationality;
    if(originator){
      if(originator.originatorType === 'CORPORATE') {
        displayNumber = originator.businessNumber;
        displayName = originator.businessName;
      } else if (originator.originatorType === 'INDIVIDUAL') {
        displayNumber = originator.idNumber;
        displayName = originator.lastName + "," + originator.firstName;
        nationality = this.props.nationalities.find(item => item.nationalityCode==originator.nationality);
        if(nationality)
          nationality = nationality.nationality;
      }
      industry = this.props.industries.find(item => item.code==originator.industry);
      if(industry) {
        industry = industry.value;
      }
    }
    let currentCustomer = this.props.currentCustomer;
    if(currentCustomer){
      isPartner = (currentCustomer['customerTierName'] && currentCustomer['customerTierName'].includes('PARTNER'));
    }

    return (
        <>
      <div className={"beneficiary-information-section"}>
        <div className="beneficiary-information-panel">
          <h6 className={"fw-600"}><FormattedMessage id="app.panel.beneficiaryinformationpanel.senderinformation"/></h6>
          <div className="bp-bordered-panel">
            <Row gutter={16}>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.relationshipwithbeneficiary"})}
                  value={reason}
                />
              </Col>
              {(isPartner && originator && originator.originatorType === 'CORPORATE') && (
                  <div>
                    <Col md={6} sm={8}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.businessnumber"})}
                          value={displayNumber}
                      />
                    </Col>
                    <Col md={6} sm={8}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.businessname"})}
                          value={displayName}
                      />
                    </Col>
                    <Col md={6} sm={24}>
                      <FieldValueVerticalCell
                          className="bp-table-cell"
                          title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.businessnature"})}
                          value={industry}
                      />
                    </Col>

                  </div>
              )}
                {(isPartner && originator && originator.originatorType === 'INDIVIDUAL') && (
                    <div>
                        <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.idnumber"})}
                                value={displayNumber}
                            />
                        </Col>
                        <Col md={6} sm={8}>
                            <FieldValueVerticalCell
                                className="bp-table-cell"
                                title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.fullname"})}
                                value={displayName}
                            />
                        </Col>
                      <Col md={6} sm={24}>
                        <FieldValueVerticalCell
                            className="bp-table-cell"
                            title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.nationality"})}
                            value={nationality}
                        />
                      </Col>

                    </div>
                )}
              <Col md={6} sm={24}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.address"})}
                  value={this.props.beneficiary.addressLine1 || this.props.beneficiary.addressLine2}
                />
              </Col>
            </Row>
          </div>
        </div>

        <div className="beneficiary-information-panel">
          <h6 className={"fw-600"}><FormattedMessage id="app.panel.beneficiaryinformationpanel.bankaccount"/></h6>
          <div className="bp-bordered-panel bp-margin-top-smallest-2">
            <Row gutter={16}>
              {/*<Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.modal.bankaccountinformationtab.account.currency"})}
                  value={this.props.beneficiary.accountCurrency}
                />
              </Col>*/}
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                    className="bp-table-cell"
                    title={intl.formatMessage({id: "app.modal.bankaccountinformationtab.transfer.currency"})}
                    value={this.props.beneficiary.transferCurrencies}
                />
            </Col><Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.bankcountry"})}
                  value={this.props.beneficiary.bankCountryName}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.bankname"})}
                  value={this.props.beneficiary.bankName}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.accountnumber"})}
                  value={this.props.beneficiary.accountNumber}
                />
              </Col>
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell bp-margin-top-smallest"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.swift"})}
                  value={this.props.beneficiary.bankCode}
                />
              </Col>
            </Row>
            <Row gutter={16}>
              {this.buildBankAccountName(this.props.beneficiary)}
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell bp-margin-top-smallest"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.bankbranchname"})}
                  value={this.props.beneficiary.bankBranchName}
                />
              </Col>
             
              <Col md={6} sm={8}>
                <FieldValueVerticalCell
                  className="bp-table-cell"
                  title={intl.formatMessage({id: "app.panel.beneficiaryinformationpanel.bankclearingcode"})}
                  value={this.props.beneficiary.clearingCode}
                />
              </Col>
            </Row>
            <Col md={12} sm={16}>
                {/*
                <FieldValueVerticalCell
                  className="bp-table-cell bp-margin-top-smallest"
                  title="Bank Address"
                  value={
                    this.props.beneficiary.bankAddressLine1 +
                    " " +
                    this.props.beneficiary.bankAddressLine2
                  }
                />
                */}
              </Col>
          </div>
        </div>

        {this.buildVirtualAccountInfo()}

        <div className="">
          {(this.props.currentUser && !this.props.currentUser.role.readOnly) && (
          <Button
              type="primary"
              onClick={() =>
                  this.props.onDeleteBeneficiaryClicked(this.props.beneficiary)
              }
          >
            <FormattedMessage id="app.panel.beneficiaryinformationpanel.deletebeneficiary"/>
          </Button>)}

          <span> </span>
          {this.state.hideEdit ==true ? (
              <span></span>
          ) : (
              (this.props.currentUser && !this.props.currentUser.role.readOnly) && (
                  <Button
                      type="primary"
                      onClick={() =>
                          this.props.edit(this.props.beneficiary.id)
                      }
                  >
                    <FormattedMessage id="app.common.edit"/>
                  </Button>)

          ) }
          {/*{(this.props.currentUser && !this.props.currentUser.role.readOnly) && (
          <Button
            type="primary"
            onClick={() =>
              this.props.edit(this.props.beneficiary.id)
            }
          >
            <FormattedMessage id="app.common.edit"/>
          </Button>)}*/}
          <span> </span>
          {this.buildVAButton()}
          <Modal title={`${intl.formatMessage({id:"app.panel.beneficiaryinformationpanel.select.channel"})}`}
                 visible={this.state.showVABrdgx}
                 size={"sm"}
                 onOk ={this.handleDbsAcc}
                 onCancel={this.hideVABrdgx}
          >
            <DbsChannelComponent handleOnVaLocationChange={this.handleOnVaLocationChange} defaultVaLocation={this.state.vaLocation}
                                 hasDBSHKVA={this.state.hasDBSHKVA} hasFlashFXVA={this.state.hasFlashFXVA}
            />
          </Modal>
        </div>
      </div>
          </>
    );
  }
}


const mapStateToProps = state =>{
  return {
    currentUser: state.user.currentUser
  }
}

const mapDispatchToProps = dispatch =>{

}

export default withRouter(
    connect(mapStateToProps,mapDispatchToProps) (
        withUseIntl(BeneficiaryInformationPanel)));